/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, April 2020
 */

import React, { PropTypes } from 'react';
import GrayPanel from '../../components/GrayPanel';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';
import waiting from '../../routes/eservices/images/waiting-wheel-300x300.gif'


const bodyStyle = {
  textAlign: 'center',
  marginTop: '100px',
  marginBottom: '100px'
}

const linkStyle = {
  color: 'inherit',
  fontWeight: 'bold',
}

class DeklaracjaDostepnosci extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    colors: 'normal',
    style: {},
    districtData: {},
    isMounted: false,
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = {};
    if (colors !== 'normal') {
      style = {
        color: headerStyle[colors].color,
      };
    }
    if (colors === 'intenseYellowBlack') {
      style = {
        color: headerStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, style });

    const url = `${process.env.API_URL}/eservices/declaration_of_availability/${this.props.prefix}/`;
    fetch(url, {
      method: 'GET',
    }).then(r => r.json())
      .then(resp => {
        this.setState({
          districtData: resp,
          isMounted: true,
        });
      });

  }

  render() {
    if (this.state.isMounted) {
      return (
        <div style={this.state.style}>
          <h1 id="a11y-deklaracja" style={{ fontSize: '2.4em'}}>
            <b>Deklaracja dostępności Portalu  e-usług E-SPDP {this.state.districtData.district_name}</b>
          </h1>
          <h2 id="oswiadczenie" style={{ fontSize: '1.6em'}}>
            <b>Oświadczenie w sprawie dostępności</b>
          </h2>
          <div id="a11y-wstep">
            <span id="a11y-podmiot"><b>{this.state.districtData.district}</b></span> zobowiązuje się zapewnić dostępność swojej strony internetowej zgodnie z ustawą z dnia 4 kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych. Oświadczenie w sprawie dostępności ma zastosowanie do <a href={`${window.location.origin}/urzad/${this.props.prefix}`} id="a11y-url" style={linkStyle}>{window.location.origin}/urzad/{this.props.prefix}</a>
            {(this.state.districtData.has_mobile_app && this.state.districtData.district === 'Urząd Miasta Gorzowa Wielkopolskiego') ? <span>, <a href={'https://play.google.com/store/apps/details?id=com.dm.giapgorzow'} id="a11y-url" style={linkStyle}>https://play.google.com/store/apps/details?id=com.dm.giapgorzow</a></span> : null}
            {(this.state.districtData.has_mobile_app && this.state.districtData.district !== 'Urząd Miasta Gorzowa Wielkopolskiego') ? <span>, <a href={'https://apps.apple.com/pl/app/euslugi-sip/id1484627587?l=pl'} id="a11y-url" style={linkStyle}>https://apps.apple.com/pl/app/euslugi-sip/id1484627587?l=pl</a>, <a href={'https://play.google.com/store/apps/details?id=com.dm.giap'} id="a11y-url" style={linkStyle}>https://play.google.com/store/apps/details?id=com.dm.giap</a></span> : null}.
          </div>
          <br/>
          <div>
            <ul>
              <li>Data publikacji: <span id="a11y-data-publikacja">{this.state.districtData.createdAt}</span>.</li>
              <li>Data ostatniej istotnej aktualizacji: <span id="a11y-data-aktualizacja">{this.state.districtData.lastUpdate}</span>.</li>
            </ul>
          </div>

          <div id="a11y-status">
            <h3><b>Status pod względem zgodności z ustawą</b></h3>
            <p>
              Strona internetowa {this.state.districtData.has_mobile_app ? 'oraz aplikacja mobilna' : null} jest <b>częściowo zgodna</b> z ustawą o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych.
            </p>
          </div>

          <div>
            <h3><b>Przygotowanie deklaracji w sprawie dostępności</b></h3>
            <ul>
              <li>Deklarację sporządzono dnia: <span id="a11y-data-sporzadzenie">{this.state.districtData.createdAt}</span></li>
              <li>Deklarację została ostatnio poddana przeglądowi i aktualizacji dnia: <span id="a11y-data-deklaracja-przeglad">{this.state.districtData.updatedAt}</span></li>
            </ul>
            <p>
            Deklarację sporządzono na podstawie samooceny. 
            </p>
          </div>

          <div id="a11y-kontakt">
            <h3><b>Informacje zwrotne i dane kontaktowe</b></h3>
            <ul>
              <li>Za rozpatrywanie uwag i wniosków odpowiada: <span id="a11y-osoba">{this.state.districtData.person_name}</span>.</li>
              <li>E-mail:  <span id="a11y-email">{this.state.districtData.person_email}</span>.</li>
              <li>Telefon: <span id="a11y-telefon">{this.state.districtData.person_phone_number}</span>.</li>
            </ul>
          </div>

          <div id="a11y-procedura">
            <p>Każdy ma prawo:</p>
            <ul>
              <li>zgłosić uwagi dotyczące dostępności cyfrowej strony lub jej elementu,</li>
              <li>zgłosić żądanie zapewnienia dostępności cyfrowej strony lub jej elementu,</li>
              <li>wnioskować o udostępnienie niedostępnej informacji w innej alternatywnej formie.</li>
            </ul>

            <p>Żądanie musi zawierać:</p>
            <ul>
              <li>dane kontaktowe osoby zgłaszającej,</li>
              <li>wskazanie strony lub elementu strony, której dotyczy żądanie,</li>
              <li>wskazanie dogodnej formy udostępnienia informacji, jeśli żądanie dotyczy udostępnienia w formie alternatywnej informacji niedostępnej.</li>
            </ul>

            <p>Rozpatrzenie zgłoszenia powinno nastąpić niezwłocznie, najpóźniej w ciągu 7 dni. Jeśli w tym terminie zapewnienie dostępności albo zapewnienie dostępu w alternatywnej formie nie jest możliwe, powinno nastąpić najdalej w ciągu 2 miesięcy od daty zgłoszenia.</p>
          </div>

          <div>
            <h3><b>Skargi i odwołania</b></h3>
            <p>Na niedotrzymanie tych terminów oraz na odmowę realizacji żądania można złożyć skargę do organu nadzorującego pocztą lub drogą elektroniczną na adres:</p>
            <ul>
              <li>Organ nadzorujący: {this.state.districtData.organ}</li>
              <li>Adres: {this.state.districtData.district_address}</li>
              <li>E-mail: {this.state.districtData.district_email}</li>
              <li>Telefon: {this.state.districtData.district_phone}</li>
            </ul>

            <p>Skargę można złożyć również do <a href="https://bip.brpo.gov.pl/pl/content/zlozenie-wniosku-do-rzecznika-praw-obywatelskich" target="_blank" style={linkStyle}>Rzecznika Praw Obywatelskich</a>.</p>
          </div>

          <div id="a11y-architektura">
            <h3><b>Dostępność architektoniczna</b></h3>

            <ol>
              <li>Na stronie internetowej można korzystać ze standardowych skrótów klawiaturowych.</li>
              {this.state.districtData.is_description_link ?
                <li>Opis dostępności architektonicznej dostępny jest na stronie <a href={this.state.districtData.description_link} id="architectural-availability-description-url" style={linkStyle}>{this.state.districtData.description_link}</a>.</li>
                : null}
              {!this.state.districtData.is_description_link && this.state.districtData.desc_list ?
                this.state.districtData.desc_list.map(
                (description, idx) => { if (!description.is_translator_description) { return (<li key={`desc_${idx}`}>{description.description}</li>); } return (null); },
                )
                : null}
              {this.state.districtData.is_translator_link ?
                <li>Informacje o możliwości skorzystania z tłumacza języka migowego dostępne są na stronie <a href={this.state.districtData.translator_link} id="architectural-availability-description-url">{this.state.districtData.translator_link}</a>.</li>
                : null}
              {!this.state.districtData.is_translator_link && this.state.districtData.desc_list ?
                this.state.districtData.desc_list.map(
                (description) => { if (description.is_translator_description) { return (<li>{description.description}</li>); } return (null); },
                )
                : null}

              {!this.state.districtData.is_translator && !this.state.districtData.is_translator_link ? <li>Brak dostępności tłumacza języka migowego za pośrednictwem środków komunikacji elektronicznej.</li> : null}
            </ol>
          </div>
          { this.state.districtData.has_mobile_app ?
            <div>
              <h3 id="a11y-aplikacje">
                <b>Aplikacje mobilne</b>
              </h3>
              <p>
                {(this.state.districtData.has_mobile_app && this.state.districtData.district === 'Urząd Miasta Gorzowa Wielkopolskiego') ? <span>Wersja Android: <a href={'https://play.google.com/store/apps/details?id=com.dm.giapgorzow'} id="a11y-url" style={linkStyle}>https://play.google.com/store/apps/details?id=com.dm.giapgorzow</a></span> : null}
                {(this.state.districtData.has_mobile_app && this.state.districtData.district !== 'Urząd Miasta Gorzowa Wielkopolskiego') ? <span>Wersja iOS: <a href={'https://apps.apple.com/pl/app/euslugi-sip/id1484627587?l=pl'} id="a11y-url" style={linkStyle}>https://apps.apple.com/pl/app/euslugi-sip/id1484627587?l=pl</a><br />Wersja Android: <a href={'https://play.google.com/store/apps/details?id=com.dm.giap'} id="a11y-url">https://play.google.com/store/apps/details?id=com.dm.giap</a></span> : null}.
              </p>
            </div>
          : null}
        </div>);
    }
    return (
      <GrayPanel
        title="Trwa ładowanie zawartości..."
        bodyStyle={bodyStyle}
      >
        <img alt="Loader" src={waiting} />
      </GrayPanel>
    )
  }
}

export default DeklaracjaDostepnosci;



// WEBPACK FOOTER //
// src/components/DeklaracjaDostepnosci/DeklaracjaDostepnosci.js